import axios from "axios";
import * as actionType from "../../../constant/actionType";

const GenerateOverallRevenueReport = (apiData) => async (dispatch) => {
 try {
  const response = await axios({
   method: "get", // Change GET to POST
   headers: {
    Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
    "Content-Type": "application/json",
   },
   url: `${actionType.environment_url}/api/admin/GenerateOverallRevenueReport`,
   params: {
    ...apiData,
  
    provider_org_ids: JSON.stringify(
        apiData.provider_org_ids?.map((item) => item?.provider_org_id)
      ),
      client_org_ids: JSON.stringify(apiData?.client_org_ids),
      
   
   },
  });

  return response.data;
 } catch (error) {
  return error.message;
 }
 
};

const GenerateOverallRevenueReportFunction = (apiData) => async (dispatch) => {
 try {
  console.log("Working ??")
  const response = await axios({
   method: "post",
   headers: {
    Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
    "Content-Type": "application/json",
   },
   url: `${actionType.environment_url}/api/admin/GenerateOverallRevenueReportFunction`,
   data: {
    ...apiData,
  
    provider_org_ids: JSON.stringify(
        apiData.provider_org_ids?.map((item) => item?.provider_org_id)
      ),
      client_org_ids: JSON.stringify(apiData?.client_org_ids),
      
   
   },
  });

  return response.data;
 } catch (error) {
  return error.message;
 }
};

export {GenerateOverallRevenueReport, GenerateOverallRevenueReportFunction};